var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m13.829 3.494-8.662 8.662a.583.583 0 0 1-.825 0l-.825-.825L.172 7.986a.583.583 0 0 1 0-.825l.825-.825a.583.583 0 0 1 .825 0l2.932 2.933 7.425-7.425a.583.583 0 0 1 .825 0l.825.825a.583.583 0 0 1 0 .825z","fill":"#502314"}));
}

Check.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Check;

Check.default = Check;
